import { StyledIconByName } from "@faire/deprecated-retailer-visitor-shared/views/product/utils/StyledIconByName";
import { Action, Expressive } from "@faire/slate/foundation/color";
import { IIconTextTile } from "@faire/web-api--source/indigofair/data/IIconTextTile";
import { Button } from "@faire/web/slate-deprecated/Button";
import { Column, Flex } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

interface IProps {
  iconTextLayoutElementData: IIconTextTile;
  onCTAClick: () => void;
}

export const IconTextTile: React.FC<IProps> = ({
  iconTextLayoutElementData,
  onCTAClick,
}) => {
  return (
    <TileWrapper $backgroundColor={iconTextLayoutElementData.background_color}>
      {iconTextLayoutElementData.icon && (
        <IconWrapper
          $backgroundColor={iconTextLayoutElementData.icon.background_color}
        >
          <StyledIconByName
            name={iconTextLayoutElementData.icon.type}
            fontSize={iconTextLayoutElementData.icon.size + "px"}
            color={iconTextLayoutElementData.icon.color}
          />
        </IconWrapper>
      )}
      <Spacer height={12} />
      <Typography variant="subheadingSansMedium">
        {iconTextLayoutElementData.main_text}
      </Typography>
      <Spacer height="1x" />
      <Typography variant="paragraphSansRegular">
        {iconTextLayoutElementData.description_text}
      </Typography>
      <Spacer height="2x" />
      <Button
        variant="tertiary"
        linkTo={iconTextLayoutElementData.cta_link}
        style={{
          minWidth: "76px",
          whiteSpace: "nowrap",
          justifyContent: "flex-start",
        }}
        onClick={onCTAClick}
      >
        <Typography color={Action.text.active}>
          {iconTextLayoutElementData.cta_text}
        </Typography>
      </Button>
    </TileWrapper>
  );
};

const TileWrapper = styled(Column).attrs({ justify: "flex-end" })<{
  $backgroundColor?: string;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  padding: ${getSpacing("2x")};
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ? $backgroundColor : Expressive.surface.orange};
`;

const IconWrapper = styled(Flex).attrs({ align: "center", justify: "center" })<{
  $backgroundColor?: string;
}>`
  width: ${getSpacing("5x")};
  height: ${getSpacing("5x")};
  border-radius: 100%;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ? $backgroundColor : Expressive.surface.neutral};
`;
